module.exports = __webpack_public_path__ + "static/media/postmates.a0ac761d.png";